import { ref, watch } from 'vue';

/**
 * Хук для разбора ошибок списочного элемента формы.
 * @property fieldName - имя списочного поля данных формы, которое получает список ошибок от API
 * @property fieldData - данные списочного поля формы (ref)
 */
export function useArrayErrors(fieldName, fieldData) {
  const errors = ref({});

  const reset = () => {
    errors.value = new Array(fieldData.value.length).fill({});
  };

  const getErrors = () => errors.value;

  const getError = (id) =>
    errors.value && id < errors.value.length ? errors.value[id] : null;

  const getFieldError = (id, field) => {
    return errors.value &&
      id < errors.value.length &&
      errors.value[id] &&
      errors.value[id][field]
      ? errors.value[id][field][0]
      : null;
  };

  const clearError = (id) => {
    if (errors.value && id < errors.value.length) {
      errors.value[id] = null;
    }
  };

  /**
   * Обрабатывает ошибки из ответа от API.
   */
  const handleApiErrors = (apiErrors) => {
    reset();

    if (apiErrors['errors'] && apiErrors['errors'][fieldName]) {
      errors.value = apiErrors['errors'][fieldName].map((el) =>
        el === null ? {} : el
      );
    }
  };

  /**
   * Возвращает ошибки из ответа API для указанного индекса в формате ответа от API.
   * @property id  Индекс элемента списка ошибок для списочного поляю
   */
  const getApiErrors = (id) => {
    return getError(id) ? { errors: getError(id) } : null;
  };

  watch(
    () => fieldData.value?.length,
    () => {
      reset();
    }
  );

  return {
    resetArrayErrors: reset,
    clearArrayError: clearError,
    getArrayErrors: getErrors,
    getArrayError: getError,
    getArrayFieldError: getFieldError,
    getArrayApiErrors: getApiErrors,
    handleArrayErrors: handleApiErrors,
  };
}
